/* eslint-disable react-hooks/exhaustive-deps */
import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';

import { isCurrentOrganisationUser } from '../../../../../../utils/activity';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { NotificationMessage } from '../../../../../../components';

class DeactivateLinkedActivityForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      linkedDeactivateLoading: false,
    };
  }

  handleValidSubmit(event, values) {
    try {
      this.setState({ linkedDeactivateLoading: true }, async () => {
        const { activity, activationToggleActivity, toggle } = this.props;
        values.status = Boolean(activity.deleted);
        await activationToggleActivity(activity.parentId, activity.id, values);
        this.setState({ linkedDeactivateLoading: false });
        toggle();
      });
    } catch (error) {
      console.error(
        'ActivityDeActivateForm -> handleValidSubmit -> error',
        error
      );
    }
  }

  render() {
    const {
      toggle,
      activity,
      guestUserOrganisation,
      permanentDelete,
      user,
      t,
    } = this.props;
    const { linkedDeactivateLoading } = this.state;
    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        autoComplete="off"
      >
        {!activity.deleted &&
          guestUserOrganisation !== null &&
          !isCurrentOrganisationUser(
            guestUserOrganisation,
            user.organisationId
          ) && (
            <NotificationMessage
              classNames="notification-segment"
              message={
                permanentDelete
                  ? t(
                      'activity.activity_plan.linked_activity.linked_activity_will_be_permanently_removed_and_assigned_to_contact_organisation'
                    )
                  : t(
                      'activity.activity_plan.linked_activity.activity_type_not_accessible'
                    )
              }
              title={t('common.warning')}
            />
          )}
        <AvField
          label={
            activity.deleted
              ? t(
                  'activity.activity_plan.linked_activity.reason_for_activation'
                )
              : t(
                  'activity.activity_plan.linked_activity.reason_for_deactivation'
                )
          }
          style={{ minHeight: '70px' }}
          name="reason"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t(
                'activity.activity_plan.linked_activity.reason_for_deactivation_is_required'
              ),
            },
          }}
          autoComplete="off"
        />
        <div className="model-buttons">
          <div>
            {' '}
            <Button
              className="Secondary-Button"
              size="small"
              type="button"
              onClick={() => toggle()}
            >
              {t('actions.cancel')}
            </Button>
          </div>
          <div>
            <Button
              loading={linkedDeactivateLoading}
              disabled={linkedDeactivateLoading}
              content={
                activity.deleted
                  ? t('actions.activate')
                  : t('actions.deactivate')
              }
              type="submit"
              size="small"
              className="Primary-Button"
            />
          </div>
        </div>
      </AvForm>
    );
  }
}

export default withTranslation()(DeactivateLinkedActivityForm);
